import React, { ReactNode } from 'react';
import Center from './alignment/Center';

interface ContentBoxProps {
  children: ReactNode;
  className?: string;
  center?: boolean;
}

const ContentBox = ({ children, className = '', center = true }: ContentBoxProps) => {
  return (
    <div className={'bg-cultured min-h-1/3 min-w-2/5 p-8 mx-8 sm:m-0 ' + className}>
      {center ? <Center>{children}</Center> : children}
    </div>
  );
};

export default ContentBox;
